export default "__VITE_ASSET__CNbpmHpG__"